/**
 * Mobile Navigation (≤ 1000 px): Burger öffnet die Navigation als Vollbild-Overlay.
 *  - Fokus ins Overlay, Rest der Seite inert, Escape schließt, Scrollen des Bodys gesperrt
 *  - Klick auf einen Anker schließt das Overlay und scrollt zum Abschnitt
 *  - Wechsel auf Desktop-Breite schließt ein offenes Overlay
 */
import { qs, qsa, setInertExcept } from '../utils/dom.js';

const MOBILE = window.matchMedia('(max-width: 1000px)');

export function init() {
	const header = qs('[data-pa-header]');
	const burger = header && qs('[data-pa-burger]', header);
	const nav = header && qs('[data-pa-nav]', header);
	if (!burger || !nav) return;

	const label = qs('[data-label-open]', burger);
	const isOpen = () => header.classList.contains('is-open');

	const open = () => {
		header.classList.add('is-open');
		burger.setAttribute('aria-expanded', 'true');
		if (label) label.textContent = label.dataset.labelClose;
		document.documentElement.style.overflow = 'hidden';
		setInertExcept([header], true);
		nav.setAttribute('tabindex', '-1');
		nav.focus({ preventScroll: true });
	};
	const close = ({ focusBurger = true } = {}) => {
		if (!isOpen()) return;
		header.classList.remove('is-open');
		burger.setAttribute('aria-expanded', 'false');
		if (label) label.textContent = label.dataset.labelOpen;
		document.documentElement.style.overflow = '';
		setInertExcept([header], false);
		nav.removeAttribute('tabindex');
		if (focusBurger) burger.focus();
	};

	burger.addEventListener('click', () => (isOpen() ? close() : open()));
	header.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen()) close(); });
	qsa('a', nav).forEach((a) => a.addEventListener('click', () => close({ focusBurger: false })));
	MOBILE.addEventListener('change', (e) => { if (!e.matches) close({ focusBurger: false }); });
}
